import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as Constants from '../constants';
import * as D from '../deps';

import './BackstageSortDropdown.scss';

const initialState: { isOpened: boolean; activeSort: keyof typeof Constants.BackstageSortTypes } = {
  isOpened: false,
  activeSort: Constants.BackstageSortTypes.Recent,
};

export interface IBackstageSortDropdownDispatchProps {
  openDropdown: typeof D.Actions.Dropdown.openDropdown;
  closeDropdown: typeof D.Actions.Dropdown.closeDropdown;
}

export interface IBackstageSortDropdownOwnProps {
  sortTypes?: $TSFixMe[];
  onSortChange?: $TSFixMeFunction;
}

export type IBackstageSortDropdownProps = IBackstageSortDropdownDispatchProps &
  IBackstageSortDropdownOwnProps;

const BackstageSortDropdown: React.FC<IBackstageSortDropdownProps> = props => {
  const { openDropdown, closeDropdown, sortTypes, onSortChange } = props;

  const [state, setState] = React.useState(initialState);
  const { isOpened, activeSort } = state;
  const dropdownRef = React.useRef(null);

  const getDropdownPosition = (): $TSFixMe => {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const el = dropdownRef.current.getBoundingClientRect();
    return {
      top: el.bottom,
      left: el.left - 4,
      height: 0,
    };
  };

  const onSortClicked = (sortType: keyof typeof Constants.BackstageSortTypes): void => {
    setState({ isOpened: false, activeSort: sortType });
    if (onSortChange) {
      onSortChange(sortType);
    }
    closeDropdown();
  };

  const onCloseDropdown = (): void => {
    setState({ isOpened: false, activeSort });
    closeDropdown();
  };

  const onClick = (e: $TSFixMe): void => {
    e.preventDefault();
    setState({ isOpened: true, activeSort });

    openDropdown({
      menuType: D.BackstageSortDropdownKey,
      config: {
        activeSort,
        onCloseDropdown,
        onSortClicked,
        position: getDropdownPosition(),
        sortTypes,
      },
    });
  };

  const iconClassnames = D.createBEM('BackstageSortDropdown__icon', {
    active: isOpened,
  });

  return (
    <button
      type='button'
      aria-haspopup='true'
      className='BackstageSortDropdown'
      onClick={onClick}
      ref={dropdownRef}
    >
      <FormattedMessage {...Constants.messages.viewBy} />
      <FormattedMessage {...Constants.BackstageSortMessages[activeSort]} />
      <D.Icon glyph={D.chevronDownIcon} className={iconClassnames} />
    </button>
  );
};

const mapDispatchToProps = {
  openDropdown: D.Actions.Dropdown.openDropdown,
  closeDropdown: D.Actions.Dropdown.closeDropdown,
};

export default connect(null, mapDispatchToProps)(BackstageSortDropdown);
